import { memo } from "react";
import { Delete } from "lucide-react";

const KEY_ROWS = [
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["Z", "X", "C", "V", "B", "N", "M"],
];

function CrosswordKeyboardInner({ onLetter, onEnter, onBackspace }) {
  return (
    <div className="px-1 pt-1 pb-1.5 flex-shrink-0 select-none" style={{ background: "var(--motif-surface)" }} data-testid="crossword-keyboard">
      {KEY_ROWS.map((row, i) => (
        <div key={row.join("")} className="flex justify-center gap-[4px] mb-[5px]">
          {i === 2 && (
            <button
              onClick={onEnter}
              className="rounded-lg font-medium text-[11px] flex items-center justify-center"
              style={{ height: 44, flex: "1.6 1 0", maxWidth: 64, background: "var(--motif-primary)", color: "var(--motif-primary-fg)" }}
              aria-label="Next unanswered clue"
              data-testid="crossword-key-enter"
            >
              Enter
            </button>
          )}
          {row.map((k) => (
            <button
              key={k}
              onClick={() => onLetter(k)}
              className="rounded-lg font-display text-base flex items-center justify-center shadow-sm"
              style={{ height: 44, flex: "1 1 0", maxWidth: 40, background: "#fff", color: "var(--motif-text)", border: "1px solid var(--motif-border)" }}
              aria-label={`Letter ${k}`}
              data-testid={`crossword-key-${k}`}
            >
              {k}
            </button>
          ))}
          {i === 2 && (
            <button
              onClick={onBackspace}
              className="rounded-lg flex items-center justify-center"
              style={{ height: 44, flex: "1.6 1 0", maxWidth: 64, background: "var(--motif-accent)", border: "1px solid var(--motif-border)" }}
              aria-label="Backspace"
              data-testid="crossword-key-backspace"
            >
              <Delete className="w-4 h-4 text-primary-motif" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}

export const CrosswordKeyboard = memo(CrosswordKeyboardInner);
